import React from 'react'
import { Link } from 'react-router-dom'
import Alert from 'components/ui/alert'
import Tooltip from 'components/ui/tooltip'
import classNames from 'clsx'
import styles from './index.module.css'

type Props = {
  address?: string
  address_2?: string
  zip?: string
  city?: string
  state?: string
  country?: string
  email?: string
  vat_number?: string
  onEdit?: (...args: Array<any>) => any
  showSections?: boolean
  disabledUpdatePaymentDetails?: boolean
  isPlanChange?: boolean
  location?: string
}

const BillingContactInformation = ({
  address,
  address_2,
  zip,
  city,
  state,
  country,
  email,
  vat_number,
  onEdit,
  showSections,
  disabledUpdatePaymentDetails,
  isPlanChange,
  location,
}: Props): React.ReactElement<'div'> | React.ReactNode => {
  const hasContact = Boolean(address && zip)
  let content = null

  if (!hasContact) {
    content = (
      <Alert status="warning" icon="warning">
        Please update your{' '}
        {disabledUpdatePaymentDetails ? (
          <span className={styles.billingContactInformationTooltipWrapper}>
            <Tooltip content="Only admins on your account can make changes to your plan.">
              <span
                className={classNames(
                  'text-link',
                  styles.billingContactInformationLink,
                  styles.billingContactInformationLinkDisabled,
                )}
              >
                billing contact information
              </span>
            </Tooltip>
          </span>
        ) : (
          <Link
            className="text-link"
            to={
              isPlanChange
                ? '/settings/billing/summary/update-billing-information-modal'
                : '/settings/billing/update-billing-information-modal'
            }
            state={{
              returnTo: location,
            }}
          >
            billing contact information
          </Link>
        )}
      </Alert>
    )
  } else {
    content = (
      <div className={styles.billingContactInformation}>
        <div className={styles.billingContactInformationContent}>
          <div className={styles.billingContactInformationContentRow}>
            {[
              showSections && (
                <span className={styles.billingContactInformationTitle}>
                  Address:
                </span>
              ),
              address,
              address_2,
              zip,
              city,
              state,
              country,
              showSections && (
                <>
                  <br />
                  <span className={styles.billingContactInformationTitle}>
                    Business details:
                  </span>
                </>
              ),
              email,
              vat_number,
            ].map((item, index) =>
              item ? (
                <React.Fragment key={index}>
                  {item} <br />
                </React.Fragment>
              ) : null,
            )}
          </div>

          {onEdit ? (
            <span
              className={classNames(
                'text-link',
                styles.billingContactInformationLink,
              )}
              onClick={onEdit}
            >
              Edit
            </span>
          ) : (
            <Link
              className="text-link"
              to={
                isPlanChange
                  ? '/settings/billing/summary/update-billing-information-modal'
                  : '/settings/billing/update-billing-information-modal'
              }
              state={{
                returnTo: location,
              }}
            >
              Edit
            </Link>
          )}
        </div>
      </div>
    )
  }

  return content
}

export default BillingContactInformation
